import React, { useState, useEffect } from 'react'
import { Card, Typography, Space, message, Spin } from 'antd'
import { Funnel } from '@ant-design/plots'
import { apiClient } from '../../../shared/api/axios-instance'

const { Title, Text } = Typography

interface FunnelData {
    stage: string
    value: number
}

export const ReferralsDashboardScreen: React.FC = () => {
    const [data, setData] = useState<FunnelData[]>([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const fetchAnalytics = async () => {
            try {
                setIsLoading(true)
                const response = await apiClient.get('/admin/referrals/analytics')
                setData(response.data.data || [])
            } catch (error: any) {
                message.error(error.response?.data?.message || 'Failed to fetch analytics')
            } finally {
                setIsLoading(false)
            }
        }
        fetchAnalytics()
    }, [])

    const config = {
        data,
        xField: 'stage',
        yField: 'value',
        shapeField: 'funnel',
        label: {
            text: (d: any) => `${d.stage}: ${d.value}`,
            style: {
                fill: '#fff',
                fontSize: 14,
            },
        },
        tooltip: {
            title: 'stage',
            items: ['value'],
        },
        legend: false as const,
    }

    return (
        <div style={{ width: '100%' }}>
            <Title level={4}>Referral Analytics</Title>

            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <Card title="Referral Conversion Funnel">
                    {isLoading ? (
                        <div style={{ textAlign: 'center', padding: 48 }}>
                            <Spin size="large" />
                        </div>
                    ) : (
                        <div style={{ height: 400 }}>
                            {data.length > 0 && data.some(d => d.value > 0) ? (
                                <Funnel {...config} />
                            ) : (
                                <div style={{ textAlign: 'center', padding: 48 }}>
                                    <Text type="secondary">No referral data available yet.</Text>
                                </div>
                            )}
                        </div>
                    )}
                </Card>
            </Space>
        </div>
    )
}
